// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JXifB","left":"styles_left__3U5p6"};